// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"4168870f","306":"4168870f","346":"4168870f","518":"4168870f","799":"4168870f","836":"4168870f","897":"5b64352b","997":"4168870f"}[chunkId] + ".chunk.css";
};